// extracted by mini-css-extract-plugin
export default {"wrapper":"MyCourses_wrapper__7WEBq","container":"MyCourses_container__FVqJo","title_block":"MyCourses_title_block__cmEHI"};